import { useState } from 'react';

import IconComponent from '../../../../common/components/IconComponent';
import useServiceConnectionIconById from '../../../ServiceConnections/Hooks/useServiceConnectionIconById';
import { ServiceConnectionRefModel } from '../../Models/ServiceConnectionModel';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';
import ServiceConnectionInputDialog from './ServiceConnectionInputDialog';

type ServiceConnectionInputProps = {
	serviceConnectionType?: string | undefined;
	serviceConnectionCategory?: string | undefined;
	serviceConnectionRef: ServiceConnectionRefModel | undefined;
	onServiceConnectionRefChange: (serviceConnectionRef: ServiceConnectionRefModel | undefined) => void;
	disabled?: boolean;
};

export function ServiceConnectionInput({
	serviceConnectionRef,
	onServiceConnectionRefChange,
	serviceConnectionType,
	serviceConnectionCategory,
	disabled,
}: ServiceConnectionInputProps) {
	const [open, setOpen] = useState(false);
	const { iconName, iconUrl } = useServiceConnectionIconById(serviceConnectionRef?.Id);
	const icon = iconUrl || iconName ? <IconComponent iconUrl={iconUrl} iconName={iconName} /> : undefined;
	return (
		<GenericPropertyInput value={serviceConnectionRef} onValueChange={onServiceConnectionRefChange} onOpen={() => setOpen(true)} disabled={disabled}>
			<GenericPropertyInputRefContent value={serviceConnectionRef} icon={icon} />
			<ServiceConnectionInputDialog
				open={open}
				setOpen={setOpen}
				serviceConnectionType={serviceConnectionType}
				serviceConnectionCategory={serviceConnectionCategory}
				value={serviceConnectionRef}
				onValueChange={onServiceConnectionRefChange}
			/>
		</GenericPropertyInput>
	);
}
